/* Gyrah soap landing — one small runtime for every gys-* section and block.
   Loaded with `defer` from several sections; the browser fetches it once. Every
   initialiser is idempotent so a section re-render in the theme editor cannot
   double-bind or stack duplicated markup. */
(function () {
  if (window.__gyrahSoap) { window.__gyrahSoap.init(); return; }

  var MOVED = 'data-gys-moved';

  /* ---------- page chrome: season bar above the header, marquee under it ---------- */
  function initChrome(root) {
    var host = (root || document).querySelector('[data-gys-chrome]');
    if (!host) return;

    if (host.dataset.season === 'true' && !document.querySelector('.gys-season[' + MOVED + ']')) {
      var tplS = host.querySelector('[data-gys-season]');
      if (tplS) {
        var bar = tplS.content.firstElementChild.cloneNode(true);
        bar.setAttribute(MOVED, '');
        document.body.insertBefore(bar, document.body.firstChild);
      }
    }
    if (host.dataset.marquee === 'true' && !document.querySelector('.gys-marq[' + MOVED + ']')) {
      var tplM = host.querySelector('[data-gys-marquee]');
      if (tplM) {
        var marq = tplM.content.firstElementChild.cloneNode(true);
        marq.setAttribute(MOVED, '');
        var hdr = document.querySelector('.shopify-section-group-header-group, #header-group, .header-section');
        if (hdr && hdr.parentNode) hdr.parentNode.insertBefore(marq, hdr.nextSibling);
        else document.body.insertBefore(marq, document.body.firstChild);
      }
    }
  }

  /* ---------- scroll helpers ---------- */
  function buyBoxTarget() {
    var atc = document.querySelector('button[name="add"]');
    if (atc) return atc;
    return document.querySelector('[id^="MainProduct"], .product-details, .product__info-wrapper, .product-information');
  }

  function scrollToY(y) {
    y = Math.max(0, Math.round(y));
    if (typeof window.scrollTo === 'function') window.scrollTo({ top: y, behavior: 'smooth' });
    var se = document.scrollingElement || document.documentElement;
    if (se && Math.abs(se.scrollTop - y) > 4) se.scrollTop = y;
  }

  function smoothTo(el) {
    if (!el) return;
    scrollToY(el.getBoundingClientRect().top + window.pageYOffset - 24);
  }

  /* The buy-box CTAs stop *above* the add-to-cart button rather than pinning it to the top
     of the screen: the bundle selector sits directly above the ATC and has to stay visible.
     The ATC is parked 24px off the bottom of the viewport, and we never scroll past the top
     of the buy box. */
  function smoothToBuyBox() {
    var atc = document.querySelector('button[name="add"]');
    if (!atc) { smoothTo(buyBoxTarget()); return; }
    var atcBottom = atc.getBoundingClientRect().bottom + window.pageYOffset;
    var y = atcBottom - window.innerHeight + 24;
    var box = atc.closest('.product-details, .product__info-container, .product__info-wrapper');
    if (box) {
      var boxTop = box.getBoundingClientRect().top + window.pageYOffset - 24;
      if (y < boxTop) y = boxTop;
    }
    scrollToY(y);
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-gys-scroll-to-buy]');
    if (cta) {
      var href = cta.getAttribute('href');
      if (!href || href === '#') { e.preventDefault(); smoothToBuyBox(); }
      return;
    }
    var anchor = e.target.closest && e.target.closest('[data-gys-anchor]');
    if (anchor) {
      var t = document.getElementById(anchor.getAttribute('data-gys-anchor'));
      if (t) { e.preventDefault(); smoothTo(t); }
      return;
    }
    var more = e.target.closest && e.target.closest('[data-gys-reviews-more]');
    if (more) {
      var wrap = more.closest('[data-gys-reviews]');
      if (!wrap) return;
      var step = parseInt(wrap.getAttribute('data-gys-step'), 10) || 6;
      var hidden = wrap.querySelectorAll('.gys-rev__row.gys-rev__hidden');
      for (var i = 0; i < step && i < hidden.length; i++) hidden[i].classList.remove('gys-rev__hidden');
      if (wrap.querySelectorAll('.gys-rev__row.gys-rev__hidden').length === 0) more.style.display = 'none';
      return;
    }
    var row = e.target.closest && e.target.closest('.gys-pb__row');
    if (row && row.getAttribute('data-state') !== 'sold') {
      var batch = row.closest('[data-gys-batch]');
      if (!batch) return;
      batch.querySelectorAll('.gys-pb__row').forEach(function (r) { r.classList.remove('is-selected'); });
      row.classList.add('is-selected');
    }
  });

  /* ---------- midnight countdown ---------- */
  var countdownTimer = null;
  function initCountdown() {
    var els = document.querySelectorAll('[data-gys-countdown]');
    if (!els.length) { if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; } return; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(23, 59, 59, 999);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      document.querySelectorAll('[data-gys-countdown]').forEach(function (el) { el.textContent = txt; });
    }
    tick();
    if (!countdownTimer) countdownTimer = setInterval(tick, 1000);
  }


  /* Arrows nudge scrollLeft by one card; the track keeps its native touch swipe untouched. */
  function initArrows(track) {
    var rail = track.parentNode;
    var prev = rail.querySelector('[data-gys-prev]');
    var next = rail.querySelector('[data-gys-next]');
    if ((!prev && !next) || track.getAttribute('data-gys-arrows-ready') === '1') return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function nudge(dir) {
      var from = track.scrollLeft;
      var to = Math.max(0, Math.min(from + dir * step(), track.scrollWidth - track.clientWidth));
      track.scrollBy({ left: to - from, behavior: 'smooth' });
      /* Smooth scrolling is inert in some embedded viewers; fall back to a direct jump. */
      setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 2) track.scrollLeft = to; sync(); }, 320);
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; sync(); }, 90);
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    track.setAttribute('data-gys-arrows-ready', '1');
  }

  /* ---------- carousel dots ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-gys-carousel]').forEach(function (track) {
      initArrows(track);
      var dots = (track.closest('.gys-soc') || track.parentNode).querySelector('[data-gys-dots]');
      if (!dots || track.getAttribute('data-gys-dots-ready') === '1') return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      dots.innerHTML = '';
      slides.forEach(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
      });
      var pending = null;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestD = Infinity;
          slides.forEach(function (s, i) {
            var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          Array.prototype.forEach.call(dots.children, function (b, i) {
            if (i === best) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          });
        }, 90);
      }, { passive: true });
      track.setAttribute('data-gys-dots-ready', '1');
    });
  }

  /* ---------- price line follows the bundle widget once it is installed ---------- */
  var priceTries = 0, priceTimer = null;
  function money(t) { var n = parseFloat(String(t).replace(/[^0-9.,]/g, '').replace(',', '.')); return isNaN(n) ? null : n; }
  function syncPrice() {
    var host = document.querySelector('[data-gys-price]');
    if (!host) return;
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (!sel) {
      var r = document.querySelector('.kaching-bundles input[type=radio]:checked');
      sel = r && r.closest('.kaching-bundles__bar');
    }
    if (!sel) return;
    var p = sel.querySelector('.kaching-bundles__bar-price');
    if (!p || !p.textContent.trim()) return;
    var nowEl = host.querySelector('[data-gys-price-now]');
    var cmpEl = host.querySelector('[data-gys-price-compare]');
    var badge = host.querySelector('[data-gys-price-badge]');
    var nowTxt = p.textContent.trim();
    if (nowEl) nowEl.textContent = nowTxt;
    var c = sel.querySelector('.kaching-bundles__bar-full-price');
    if (c && c.textContent.trim() && cmpEl && badge) {
      var cTxt = c.textContent.trim();
      cmpEl.textContent = cTxt; cmpEl.style.display = '';
      var pn = money(nowTxt), cn = money(cTxt);
      if (pn != null && cn != null && cn > pn) {
        badge.textContent = (badge.getAttribute('data-prefix') || 'Save') + ' ' + Math.round((1 - pn / cn) * 100) + '%';
        badge.style.display = '';
      } else { badge.style.display = 'none'; }
    } else if (cmpEl && badge) { cmpEl.style.display = 'none'; badge.style.display = 'none'; }
  }
  function initPrice() {
    if (!document.querySelector('[data-gys-price]')) return;
    var badge = document.querySelector('[data-gys-price-badge]');
    if (badge && !badge.getAttribute('data-prefix')) {
      badge.setAttribute('data-prefix', (badge.textContent.trim().split(' ')[0]) || 'Save');
    }
    if (priceTimer) return;
    priceTries = 0;
    priceTimer = setInterval(function () {
      priceTries++;
      if (document.querySelector('.kaching-bundles__bar')) { clearInterval(priceTimer); priceTimer = null; syncPrice(); }
      else if (priceTries > 40) { clearInterval(priceTimer); priceTimer = null; }
    }, 250);
  }
  document.addEventListener('change', function (e) {
    if (e.target && /kaching/.test(e.target.name || '')) setTimeout(syncPrice, 60);
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.kaching-bundles__bar')) setTimeout(syncPrice, 150);
  });

  function init(root) {
    initChrome(root);
    initCountdown();
    initCarousels(root);
    initPrice();
  }

  window.__gyrahSoap = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    document.querySelectorAll('.gys-season[' + MOVED + '], .gys-marq[' + MOVED + ']').forEach(function (el) { el.remove(); });
    init(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
